export default valuesObject => Object.entries(valuesObject)
  .reduce((acc, [key, values]) => ({
    ...acc,
    [key]: values.length > 1 ? values : values[0]
  }), {})
